import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './index.css';

import { BrowserRouter , Switch ,Route} from 'react-router-dom';
import { Provider } from 'react-redux'
import {store,persistor} from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import Login from './screens/login/login'
import ForgetPassword from './screens/forgetPassword/forgetPassword'
import Splash from './screens/splash/splash'
import UserInfo from './screens/user info/user info'
import User from './screens/user/user'
import Admins from './screens/admin/admin'
import Search from './screens/search/search'
import Questions from './screens/question/question';
import QuestionsInfo from './screens/question info/question info';
import addQuestions from './screens/add question/add question';
import AddUser from './screens/add user/add user'
import setting from './screens/setting/setting';
import contactus from './screens/contactus/contactus';
import sendNotifs from './screens/send notifs/send notifs';
import Home from './screens/home/Home';
import About from './screens/about/about';
import Locations from './screens/location/location';
import LocationInfo from './screens/location info/location info';
import AddLocation from './screens/add location/add location';
import Categories from './screens/categories/categories';
import CategoryInfo from './screens/category info/category info';
import AddCategory from './screens/add category/add category';
import Countries from './screens/countries/countries';
import CountryInfo from './screens/country info/country info'
import CityInfo from './screens/city info/city info'
import AddCountry from './screens/add country/add country'
import Permissions from './screens/permission/permission';
import PermissionInfo from './screens/permission info/permission info'
import AddPermission from './screens/add permission/add permission'
import Supervisors from './screens/supervisor/supervisor';

import Clients from './screens/clients/clients';
import ClientInfo from './screens/client info/client info';
import Guidelines from './screens/guideline/guideline';
import GuidelineInfo from './screens/guideline info/guideline info'
import AddGuideline from './screens/add guideline/add guideline'
import SalesMen from './screens/sales man/sales man'
import Anoncement from './screens/anoncement/anoncement';
import AnoncementInfo from './screens/anoncement info/anoncement info';
import AddAnoncement from './screens/add anoncement/add anoncement';
ReactDOM.render(
  
<Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter >
      <Switch>
        <Route path={"/Login"} component={Login}/> 
        <Route exact path={"/"} component={Splash}/> 
        <Route path={"/forgetPassword"} component={ForgetPassword}/>
        <App path={'/anoncements'} component={Anoncement}/> 
        <App path={'/AnoncementInfo'} component={AnoncementInfo}/> 
        <App path={'/AddAnoncement'} component={AddAnoncement}/> 

        <App path={'/GuidelineInfo'} component={GuidelineInfo}/> 
        <App path={'/Guidelines'} component={Guidelines}/> 
        <App path={'/AddGuideline'} component={AddGuideline}/> 
        <App path={'/Sales-men'} component={SalesMen}/>
        <App path={'/Supervisors'} component={Supervisors}/> 
        <App path={'/PermissionInfo'} component={PermissionInfo}/> 
        <App path={'/Permissions'} component={Permissions}/> 
        <App path={'/AddPermission'} component={AddPermission}/> 
        <App path={'/Countries'} component={Countries}/>
        <App path={'/CountryInfo'} component={CountryInfo}/>
        <App path={'/CityInfo'} component={CityInfo}/>
        <App path={'/AddCountry'} component={AddCountry}/>
        <App path={'/Clients'} component={Clients}/> 
        <App path={'/ClientInfo'} component={ClientInfo}/> 
        <App path={'/LocationInfo'} component={LocationInfo}/> 
        <App path={'/Locations'} component={Locations}/> 
        <App path={'/AddLocation'} component={AddLocation}/>
        <App path={'/Categories'} component={Categories}/> 
        <App path={'/CategoryInfo'} component={CategoryInfo}/> 
        <App path={'/AddCategory'} component={AddCategory}/>  
        <App path={'/Questions'} component={Questions}/>
        <App path={'/questionInfo'} component={QuestionsInfo}/>
        <App path={'/AddQuestion'} component={addQuestions}/>
        <App path={'/Search'} component={Search}/>
        <App path={'/about'} component={About}/>
        <App path={'/Home'} component={Home}/>
        <App path={'/users'} component={User}/>
        <App path={'/Admins'} component={Admins}/>
        <App path={'/userInfo'} component={UserInfo}/>
        <App path={'/addUser'} component={AddUser}/>
        <App path={'/Setting'} component={setting}/>
        <App path={'/ContactUs'} component={contactus}/>
        <App path={'/SendNotifs'} component={sendNotifs}/>
        
      </Switch>
    </BrowserRouter>
  </PersistGate>
</Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
